import { render } from "./MainFooter.vue?vue&type=template&id=7ec29de6&scoped=true"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"

import "./MainFooter.vue?vue&type=style&index=0&id=7ec29de6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec29de6"]])

export default __exports__